export const COVERAGE = {
  BUILDING: 'coverageBuildings',
  HOME: 'coverageHomes',
  LIABILITY: 'coverageLiabilities',
};

export enum SORTING_OPTIONS {
  Price = 0,
  Highest_Test_Score = 1,
}

export const SORTING_ASCENDING_ORDER = {
  [SORTING_OPTIONS.Price]: false,
  [SORTING_OPTIONS.Highest_Test_Score]: true,
};

export const SORTING_REFERENCE = {
  [SORTING_OPTIONS.Price]: 'price.month.total',
  [SORTING_OPTIONS.Highest_Test_Score]: 'price.month.total',
};

export const HOW_IT_WORKS = {
  AFFILIATE: 'How it works-affiliate',
  CONFIRMATION_COMPANY: 'How it works-confirmation_company',
  CONFIRMATION_CB: 'How it works-confirmation_cb',
  CANCEL_OLD: 'How it works-cancel_old',
  SERVICE: 'How it works-service',
  DELIVERY: 'How it works-delivery',
  ORDER: 'How it works-order',
  CHECK: 'How it works-check',
  PLAN: 'How it works-plan',
  INSTALLATION: 'How it works-installation',
};
